/* eslint-disable max-len */
import React from 'react';

const RedoIcon = props => (
  <svg
    width="8px"
    height="14px"
    viewBox="0 0 8 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-107.000000, -18.000000)" fill="currentColor">
        <g transform="translate(48.000000, 0.000000)">
          <path
            d="M66.7880657,25.7733007 C66.7880657,22.8223007 64.3950657,20.4293007 61.4440657,20.4293007 C61.1920657,20.4293007 60.9420657,20.4363007 60.6950657,20.4503007 L61.9420657,19.2053007 C62.0970657,19.0503007 62.0970657,18.8003007 61.9420657,18.6453007 C61.7870657,18.4913007 61.5370657,18.4913007 61.3820657,18.6453007 L59.4230657,20.6053007 C59.2680657,20.7593007 59.2680657,21.0093007 59.4230657,21.1653007 L61.3820657,23.1243007 C61.5370657,23.2783007 61.7870657,23.2783007 61.9420657,23.1243007 C62.0970657,22.9693007 62.0970657,22.7183007 61.9420657,22.5643007 L60.6260657,21.2473007 C60.8950657,21.2293007 61.1680657,21.2213007 61.4440657,21.2213007 C63.9580657,21.2213007 65.9960657,23.2593007 65.9960657,25.7733007 C65.9960657,28.2873007 63.9590657,30.3243007 61.4460657,30.3253007 L61.1770657,30.3253007 C60.9610657,30.3253007 60.7850657,30.5013007 60.7850657,30.7173007 L60.7850657,30.7253007 C60.7850657,30.9413007 60.9610657,31.1173007 61.1770657,31.1173007 L61.5080657,31.1173007 C61.5310657,31.1173007 61.5510657,31.1083007 61.5730657,31.1043007 C64.4630657,31.0343007 66.7880657,28.6803007 66.7880657,25.7733007"
            transform="translate(63.047441, 24.823551) scale(-1, 1) translate(-63.047441, -24.823551) "
          />
        </g>
      </g>
    </g>
  </svg>
);
export default RedoIcon;
